import {useQueries} from "@tanstack/react-query";
import userService from "../../../../services/web/user-service.js";
import teamService from "../../../../services/web/team-service.js";
import areaLayerService from "../../../../services/web/area-layer-service.js";

const UseFetchOptions = () => {

    const queries = useQueries({
        queries: [
            {
                queryKey: ['guardOpt'],
                queryFn: () => userService.allowedOnly(),
                initialData: []
            },
            {
                queryKey: ['teamOpt'],
                queryFn: () => teamService.getAllTeams(),
                initialData: []
            },
            {
                queryKey: ['sectorOpt'],
                queryFn: () => areaLayerService.allSectors(),
                initialData: []
            }
        ]
    });

    return {
        guardOpt: queries[0].data,
        teamOpt: queries[1].data,
        sectorOpt: queries[2].data,
    };
};

export default UseFetchOptions;